<template>
  <v-card flat>
    <v-card-text>
      <v-text-field
        dense
        outlined
        prepend-inner-icon="mdi-magnify"
        :label="$t('components.QuickLinkList.search')"
        v-model="searchPattern"
        ref="search"
        autofocus
      ></v-text-field>
    </v-card-text>
    <v-list v-if="searchPattern" class="mt-n8">
      <v-list-item-group>
        <v-list-item :to="`/partners/${partnerId}/quick-links?search=${searchPattern}`" v-if="limitDisplay">
          <v-list-item-avatar>
            <v-icon> mdi-magnify </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ searchPattern }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t("components.QuickLinkList.searchHint") }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-subheader v-if="filteredList.length">{{ $t("components.QuickLinkList.bestHits") }}</v-subheader>
        <span v-for="(searchResult, idx) in filteredList" :key="idx">
          <navigation-list-item :navigationItem="searchResult.item" />
        </span>
      </v-list-item-group>
    </v-list>
    <v-list v-else-if="limitDisplay" class="mt-n8">
      <v-subheader>{{ $t("components.QuickLinkList.favs") }}</v-subheader>
      <v-list-item-group>
        <span v-for="(quicklink, idx) in favLinks" :key="idx">
          <navigation-list-item :navigationItem="quicklink" />
        </span>
      </v-list-item-group>
    </v-list>
    <div v-else>
      <div v-for="(quicklinkC, idx1) in forUserContextAvailableQuickLinksWithSubheaders" :key="idx1">
        <v-subheader>{{ $t("navCategory." + quicklinkC.category) }}</v-subheader>
        <v-list>
          <v-list-item-group>
            <span v-for="(quicklink, idx) in quicklinkC.items" :key="idx">
              <navigation-list-item :navigationItem="quicklink" />
            </span>
          </v-list-item-group>
        </v-list>
      </div>
    </div>

    <v-divider v-if="limitDisplay"> </v-divider>
    <v-card-text v-if="limitDisplay">
      <v-list-item @click="goToQuickLinks()">
        <v-list-item-content>
          <v-list-item-subtitle v-if="limitDisplay">{{
            $t("components.QuickLinkList.allFunctions")
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { ICustomRouteConfig } from "@/store/interface/custom.route.config.interface";
import { NavigationModule } from "@/store/modules/navigation.store";
import { PartnerModule } from "@/store/modules/partner";
import Fuse from "fuse.js";
import { Component, Prop, Vue } from "vue-property-decorator";
import NavigationListItem from "./NavigationListItem.vue";

@Component({
  components: {
    NavigationListItem
  }
})
export default class QuickLinkList extends Vue {
  @Prop({ default: false })
  limitDisplay!: boolean;

  @Prop({ default: false })
  parseQuery!: boolean;

  searchPattern = "";

  goTo(route: ICustomRouteConfig) {
    this.$router.push({ name: route.name, params: { partnerId: this.partnerId } });
  }

  goToQuickLinks() {
    this.$router.push({ name: "QuickLinks", params: { partnerId: this.partnerId } });
  }

  get navigationCon() {
    return NavigationModule.navigationConfiguration;
  }

  mounted() {
    if (this.parseQuery) {
      const value = this.$route.query["search"];

      if (Array.isArray(value) && value.length) {
        this.searchPattern = value[0] as string;
      } else if (value) {
        this.searchPattern = value as string;
      }
    }
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  get filteredList() {
    const fuseOptions = {
      // isCaseSensitive: false,
      // includeScore: false,
      // shouldSort: true,
      // includeMatches: false,
      // findAllMatches: false,
      // minMatchCharLength: 1,
      // location: 0,
      // threshold: 0.6,
      // distance: 100,
      // useExtendedSearch: false,
      // ignoreLocation: false,
      // ignoreFieldNorm: false,
      // fieldNormWeight: 1,
      keys: ["title", "description", "tags", "category"]
    };

    const fuse = new Fuse(this.allQuickLinks, fuseOptions);

    if (this.limitDisplay) {
      return fuse.search(this.searchPattern, { limit: 5 });
    } else {
      return fuse.search(this.searchPattern);
    }
  }

  /**
   *
   */
  get forUserContextAvailableQuickLinksWithSubheaders() {
    return NavigationModule.quickLinksWithSubheader;
  }

  get quickLinkCategories() {
    return NavigationModule.quickLinkCategories;
  }

  get favLinks() {
    if (this.limitDisplay) {
      if (this.allQuickLinks.length > 5) {
        return this.allQuickLinks.slice(0, 5);
      }
    }
    return this.allQuickLinks;
  }

  get allQuickLinks() {
    return NavigationModule.quickLinks;
  }
}
</script>
